<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['options','height','data'],
  methods: {
    newData: function() {
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            data: this.rliss,
            fill: true,
            backgroundColor: "rgba(123,111,255, 1)", // <-- supposed to be light blue
            // borderColor: "#41c6ff",
            label: "RLISS"
          },
          {
            data: this.accomp,
            fill: true,
            backgroundColor: "rgba(111,255,133, 1)", // <-- supposed to be light blue
            // borderColor: "#41c6ff",
            label: "Accompagnateurs"
          },
          {
            data: this.usagers,
            fill: true,
            backgroundColor: "rgba(255,152,111, 1)",
            // borderColor: "#ffb041",
            label: "Fournisseurs"
          },
        ]},
        {
          title: {
            display: true,
            fontSize: 20,
            text: 'Connexions journalières'
          },
          // responsive: false,
          // Can't just just `stacked: true` like the docs say
          scales: {
            // xAxes: [{ stacked: true }],
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Nombre d\'usagers'
              },
              stacked: true,
            }]
          },
          animation: {
            duration: 750,
          },
        }
      )
    }
  },
  computed: {
    labels: function() {
      let result = [];
      for(var value of this.data) {
        result.push(value.date.substring(5, 10));
      }
      return result;
    },
    // datasets
    accomp: function() {
      return this.data.map(x => x.countAccompagnateur);
    },
    usagers: function() {
      return this.data.map(x => x.countUsagers);
    },
    rliss: function() {
      return this.data.map(x => x.countRliss);
    }

  },
  watch: {
    data: function() {
      this.newData();
    }
  },
  mounted() {
    this.newData();
  }
}
</script>
